import React from 'react';
import { Search } from 'lucide-react';
import { Customer } from '../../../types';

interface ProjectRequestFiltersProps {
  customers: Customer[];
  selectedCustomer: number | '';
  setSelectedCustomer: (val: number | '') => void;
  status: string;
  setStatus: (val: string) => void;
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  onRefresh: () => void;
}

const ProjectRequestFilters: React.FC<ProjectRequestFiltersProps> = ({
  customers,
  selectedCustomer,
  setSelectedCustomer,
  status,
  setStatus,
  searchQuery,
  setSearchQuery,
  onRefresh,
}) => {
  return (
    <>
      <div className="flex flex-wrap gap-2 items-end mb-3">
        <div>
          <label className="block text-sm font-medium mb-0.5 theme-text-primary">ClientTRAC</label>
          <select
            className="border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary"
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value ? Number(e.target.value) : '')}
          >
            <option value="">All</option>
            {customers.map((c) => (
              <option key={c.id} value={c.id}>{c.item}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-0.5 theme-text-primary">Status</label>
          <select
            className="border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">All</option>
            <option value="submitted">Submitted</option>
            <option value="in_review">In Review</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <button
          onClick={onRefresh}
          className="px-4 py-2 rounded-lg theme-bg-secondary text-white theme-border hover:opacity-80 transition-colors focus:outline-none theme-text-primary custom-button"
        >
          Refresh
        </button>
      </div>

      {/* Search Bar */}
      <div className="mb-3">
        <div className="relative">
          <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 theme-text-tertiary w-4 h-4" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by project, customer, submitter, funding, or work type..."
            className="w-full pl-10 pr-4 py-2 theme-border rounded-lg border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary  border border-white theme-bg-primary theme-text-primary input-border1"
          />
        </div>
      </div>
    </>
  );
};

export default ProjectRequestFilters;
